import { render, staticRenderFns } from "./GoldStoneJpglistModal.vue?vue&type=template&id=18a43aca&"
import script from "./GoldStoneJpglistModal.vue?vue&type=script&lang=js&"
export * from "./GoldStoneJpglistModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports